import OfferEvaluationStepImportOfferSubmissions from './OfferEvaluationStepImportOfferSubmissions';
import OfferEvaluationStepReviewOffers from './OfferEvaluationStepReviewOffers';
import OfferEvaluationStepPriceComparison from './OfferEvaluationStepPriceComparison';
import OfferEvaluationStepSelectionCriteria from './OfferEvaluationStepSelectionCriteria';
import OfferEvaluationStepCreateDocuments from './OfferEvaluationStepCreateDocuments';
import OfferEvaluationStepAwardCriteria from './OfferEvaluationStepAwardCriteria';
import OfferEvaluationStepCreateTender from './OfferEvaluationStepCreateTender';

export const STEPS = [
    ['Create Tender', <OfferEvaluationStepCreateTender />],
    ['Import Offer Submissions', <OfferEvaluationStepImportOfferSubmissions />],
    ['Review Offer Submissions', <OfferEvaluationStepReviewOffers />],
    ['Selection Criteria', <OfferEvaluationStepSelectionCriteria />],
    ['Price Comparison', <OfferEvaluationStepPriceComparison />],
    ['Award Criteria', <OfferEvaluationStepAwardCriteria />],
    ['Create Documents', <OfferEvaluationStepCreateDocuments />],
] as const;

export const STEP_IMPORT_OFFER_SUBMISSIONS = 1;
